import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { wwAppLayout } from '../shell/appLayout';

/** The wibblewabble product experience, mounted at the app root. */
const dashboardPage = PageBlueprint.make({
  name: 'dashboard',
  params: {
    path: '/',
    noHeader: true,
    loader: () => import('./WibblewabbleRoot').then(m => <m.WibblewabbleRoot />),
  },
});

/** Terms of Service — linked from the sign-in/sign-up checkbox. */
const termsPage = PageBlueprint.make({
  name: 'terms',
  params: {
    path: '/terms',
    noHeader: true,
    loader: () => import('./TermsPage').then(m => <m.TermsPage />),
  },
});

/**
 * Public product documentation — the shareable manual at /docs. Rendered
 * pre-auth by the sign-in page (invite-only app, but the docs are open); this
 * registration serves the same pages to signed-in users. Catch-all path so
 * deep links like /docs/request-a-budget resolve to the same shell.
 */
const docsPage = PageBlueprint.make({
  name: 'docs',
  params: {
    path: '/docs',
    noHeader: true,
    loader: () => import('./docs/DocsPage').then(m => <m.DocsPage />),
  },
});

/**
 * Frontend module for the wibblewabble product experience. Registered under the
 * app plugin so it can override the app layout (remove the sidebar) and own the
 * root route.
 */
export const productModule = createFrontendModule({
  pluginId: 'app',
  extensions: [wwAppLayout, dashboardPage, termsPage, docsPage],
});
